import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, [
        'switchName',
        'durationMinutesStart',
        'durationMinutesEnd',
      ])}`
    : '';
  const getNonBroadsoftZeroDurationCdrsReport = `getNonBroadsoftZeroDurationCdrsReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getNonBroadsoftZeroDurationCdrsReport} {
        startTime
        endTime
        direction
        callingNumber
        calledNumber
        answerTime
        sreserved
        disconnectReason
        failureCode
        incomingRoute
        outgoingRoute
        callStatus
        terminatingAccess
        extIddAbc
        extIdoBcd
        callDuration
        commercial
        partySipCallIdZero
        partySipCallIdOne
        extDurationMinutes
        extDurationSeconds
      }
    }
  `;
};
